import { Carousel } from "react-bootstrap";
import "./Slider.css";
import useDataFetcher from "../../hooks/useDataFetcher";

export default function Slider() {
  // const { data, loading, error } = useDataFetcher(
  //   "http://localhost:5000/api/ServicesPosts"
  // );

  const data = [
    {
      title: "Gayrimenkul ve İnşaat Hukuku\n",
      content:
        "Gayrimenkul ve inşaat projelerinin her aşamasında hukuki destek sağlıyoruz. Tapu işlemleri, kira sözleşmeleri, inşaat sözleşmeleri, projelerin hukuki denetimi ve ihtilaf çözümü konularında müvekkillerimize rehberlik ediyoruz.\n",
      image:
        "https://st5.depositphotos.com/16122460/64670/i/450/depositphotos_646707466-stock-photo-construction-land-law-concepts-judge.jpg",
      id: 1,
    },
    {
      title: "Ceza Hukuku",
      content:
        "Ceza hukuku alanında savunma ve suçtan zarar görmüş kişilere yönelik hukuki hizmetler sunuyoruz. Haksız suçlamalara karşı savunma yaparken, suç mağdurları için de adaletin sağlanmasına yönelik çözümler sunuyoruz.\n",
      image:
        "https://st.depositphotos.com/1000163/2482/i/450/depositphotos_24824379-stock-photo-handcuffs-and-judge-gavel-on.jpg",
      id: 2,
    },
    {
      title: "İflas ve Konkordato Hukuku",
      content:
        "İflas ve konkordato süreçlerinde müvekkillerimize finansal sorunlarının çözümünde yardımcı oluyoruz. Borçların yeniden yapılandırılması, ödeme planları ve yasal düzenlemelerle ilgili profesyonel destek sağlıyoruz.",
      image:
        "https://media.istockphoto.com/id/155431941/tr/foto%C4%9Fraf/bankrupcy-law.jpg?s=612x612&w=0&k=20&c=nw2GuRQThI7_nTj4IRIZ8qWivpORMba40n0zxZKmO8c=",
      id: 3,
    },
    {
      title: "İcra ve İflas Hukuku",
      content:
        "Alacakların tahsili ve borçlunun iflası durumlarında hukuki çözüm sunuyoruz. İcra takibi, haciz işlemleri ve borçlunun mallarına ilişkin tüm işlemlerde müvekkillerimizi doğru şekilde yönlendiriyoruz.",
      image:
        "https://media.istockphoto.com/id/155431941/tr/foto%C4%9Fraf/bankrupcy-law.jpg?s=612x612&w=0&k=20&c=nw2GuRQThI7_nTj4IRIZ8qWivpORMba40n0zxZKmO8c=",
      id: 4,
    },
    {
      title: "İş Hukuku",
      content:
        "İşverenler ve çalışanlar arasında çıkan uyuşmazlıkların çözümünde uzmanız. İş sözleşmeleri, kıdem tazminatı, işçi hakları, iş yerinde ayrımcılık, iş güvenliği gibi birçok alanda danışmanlık ve dava hizmeti veriyoruz.",
      image:
        "https://st5.depositphotos.com/16122460/64670/i/450/depositphotos_646707466-stock-photo-construction-land-law-concepts-judge.jpg",
      id: 5,
    },
    {
      title: "Aile Hukuku",
      content:
        "Boşanma, nafaka, çocukların velayeti, mal paylaşımı gibi aile içi sorunlarda taraflara hukuki çözüm önerileri sunuyoruz. Aile içi anlaşmazlıklarda empatik ve çözüm odaklı bir yaklaşım benimseyerek müvekkillerimize destek sağlıyoruz.",
      image:
        "https://media.istockphoto.com/id/1254581589/tr/foto%C4%9Fraf/aile-hukuku.jpg?s=612x612&w=0&k=20&c=En8YFSLq892MVsTZfsM-22n2i1T8nRV_FT7136uvtL0=",
      id: 6,
    },
    {
      title: "Ticaret Hukuku",
      content:
        "Şirketlerin ticari faaliyetlerini düzenleyen sözleşmeler, ortaklık anlaşmaları, şirket birleşmeleri ve ticari uyuşmazlıkların çözümü konusunda uzmanlık sağlıyoruz. Ticaret hayatındaki her aşamada hukuki rehberlik ediyoruz.",
      image:
        "https://st4.depositphotos.com/1010613/21557/i/450/depositphotos_215579784-stock-photo-close-brown-gavel-shopping-cart.jpg",
      id: 2004,
    },
  ];
  const loading = false;
  const error = null;

  return (
    <>
      {loading && <p>Loading...</p>}
      {error && <p>Error: {error}</p>}
      {!loading && !error && (
        <Carousel loading="lazy">
          {data.map((slide) => (
            <Carousel.Item key={slide.id}>
              <img
                id="carousel-img"
                className="d-block w-100"
                src={slide.image}
                alt={slide.title}
                height={600}
              />
              <Carousel.Caption>
                <h1>{slide.title}</h1>
                <p>{slide.content}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </>
  );
}
